import { useSettings } from "../../contexts/Settings";
import { usePlaybackRate } from "../../contexts/PlaybackRate";
import { Modal } from "../Modal";
import { Row } from "../Modal/Row";
import { ModalLocation } from "../../types/modalLocation";

export const PlaybackRateModal = () => {
  const { setShowPlaybackRateModal, showPlaybackRateModal } = useSettings();
  const { setPlaybackRate, playbackRates, playbackRate } = usePlaybackRate();

  const closeSelf = () => {
    setShowPlaybackRateModal(false);
  };

  const selectPlaybackRate = (rate: number) => {
    setShowPlaybackRateModal(false);
    setPlaybackRate(rate);
  };

  return (
    <Modal
      modalLocation={ModalLocation.bottomRight}
      closeSelf={closeSelf}
      show={showPlaybackRateModal}
    >
      {playbackRates?.map((rate) => {
        const onClick = () => {
          selectPlaybackRate(rate);
        };

        return (
          <Row
            key={rate}
            onClick={onClick}
            selected={playbackRate === rate}
            label={`${rate}x`}
          />
        );
      })}
    </Modal>
  );
};
